import { render, staticRenderFns } from "./planDetail.vue?vue&type=template&id=ed364ac0"
import script from "./planDetail.vue?vue&type=script&lang=ts"
export * from "./planDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports